import Vue from 'vue'
import {
    Icon,
    Dialog,
    Popover,
    Button,
    Card,
    Input,
    Form,
    FormItem,
    Tooltip,
    // Collapse,
    // CollapseItem
} from 'element-ui';

Vue.use(Popover);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Card);
Vue.use(Input);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Tooltip);
// Vue.use(Collapse);
// Vue.use(CollapseItem)


// WEBPACK FOOTER //
// ./src/units/elementui.js